import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { GiftIcon } from 'lucide-react';
export function BonusSection() {
  const bonuses = [{
    id: 1,
    title: 'Guía de Pueblos Antiguos',
    value: 19
  }, {
    id: 2,
    title: 'Cronología Bíblica Ilustrada',
    value: 29
  }, {
    id: 3,
    title: 'Atlas de Mapas Bíblicos',
    value: 15
  }, {
    id: 4,
    title: 'Diccionario de Lugares Sagrados',
    value: 25
  }, {
    id: 5,
    title: 'Guía del Templo de Salomón',
    value: 19
  }, {
    id: 6,
    title: 'Guía de Estudio Interactiva',
    value: 15
  }, {
    id: 7,
    title: 'Actualizaciones de Por Vida',
    value: null
  }];
  return <section className="py-14 bg-navy relative" data-id="element-32">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-navy-800 via-navy-900 to-navy-900" data-id="element-33"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-34">
        <FadeIn className="text-center mb-8" data-id="element-35">
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-gold mb-3" data-id="element-36">
            Reclama Estos{' '}
            <span className="underline decoration-gold decoration-2 underline-offset-4" data-id="element-37">
              7 Bonos Exclusivos
            </span>{' '}
            Si Ordenas HOY
          </h2>
          <p className="text-lg text-gray-300" data-id="element-38">
            <em data-id="element-39">
              Si entras hoy, te daré 7 bonos especiales por tiempo limitado…
            </em>
          </p>
        </FadeIn>

        <div className="bg-gradient-to-b from-cream to-white rounded-2xl p-1 shadow-2xl" data-id="element-40">
          <div className="bg-white rounded-[0.875rem] border-2 border-gold/30 p-4 md:p-6" data-id="element-41">
            <div className="space-y-2.5" data-id="element-42">
              {bonuses.map((bonus, index) => <FadeIn key={bonus.id} delay={index * 0.06} data-id="element-43">
                  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 p-3.5 rounded-lg bg-cream border border-gold/20" data-id="element-44">
                    <div className="flex items-center gap-3" data-id="element-45">
                      <div className="w-10 h-10 rounded-full bg-gold/20 flex items-center justify-center flex-shrink-0" data-id="element-46">
                        <GiftIcon className="w-5 h-5 text-gold-600" data-id="element-47" />
                      </div>
                      <div data-id="element-48">
                        <span className="text-xs font-bold text-gold-600 uppercase tracking-wider block" data-id="element-49">
                          Bono #{bonus.id}
                        </span>
                        <h4 className="text-base md:text-lg font-bold text-navy-900" data-id="element-50">
                          {bonus.title}
                        </h4>
                      </div>
                    </div>

                    <div className="flex items-center gap-2 sm:flex-col sm:items-end sm:gap-0.5 pl-13 sm:pl-0" data-id="element-51">
                      {bonus.value !== null ? <>
                          <span className="text-red-500 line-through text-xs font-medium" data-id="element-52">
                            Precio Regular ${bonus.value}
                          </span>
                          <span className="text-green-600 font-bold text-lg uppercase" data-id="element-53">
                            GRATIS
                          </span>
                        </> : <span className="text-green-600 font-bold text-lg uppercase" data-id="element-54">
                          GRATIS
                        </span>}
                    </div>
                  </div>
                </FadeIn>)}
            </div>

            <FadeIn delay={0.5} className="mt-5 pt-5 border-t-2 border-dashed border-gray-200 text-center" data-id="element-55">
              <p className="text-gray-500 font-medium mb-1 text-sm" data-id="element-56">
                Valor Total de los Bonos:
              </p>
              <p className="text-3xl font-bold font-heading text-navy-900 mb-3" data-id="element-57">
                +$120 USD
              </p>
              <div className="inline-block bg-green-100 text-green-800 font-bold text-lg md:text-xl px-6 py-2 rounded-full border border-green-200" data-id="element-58">
                ¡TODOS GRATIS SI ORDENAS HOY!
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}